import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";

import { useDispatch, useSelector } from "react-redux";
import { playAudio, playMyMixer, playMyMixerObj } from "../../Store/Slices/SoundPlayerSlice";

import axios from "axios";

import BASEURL from "../../Config/global";
import MainLayout from "../../Layout/MainLayout";
import { useTranslation } from "react-i18next";

import { BackButton, BackButtonNew, OutlinePause, OutlinePlay, PauseButton, PlayButton } from "../../Assets/svg";
import "./style.css";
import { pauseMixer, playMixer } from "../../Store/Slices/MixerSlice";
import VolumeBar from "../../Components/VolumeBar";
import ReactAudioPlayer from "react-audio-player";
import { AudioDurationClose, AudioDurationCurrentTime, AudioDurationStop, AudioSeek } from "../../Store/Slices/AudioSlice";
import { Link } from "react-router-dom";
import AudioStrip from "../../Components/AudioStrip";
import { isIOS, isSafari } from "react-device-detect";
import { Howl, Howler } from "howler";
import { activeUser, userLogout } from "../../Store/Slices/APIs";
// import { FillPlay, FillPause, TrackedPlay } from '../Assets/svg';
import CryptoJS from 'crypto-js';
import { ClearExternalMixData, handleMixerTray } from "../../Store/Slices/MyMixerSlice";
import { addMultipleTracks, playAllTracks, resetConfig, setConfig, setPlayingConfig, togglePlayPause } from "../../Store/Slices/PlayerSlice";
import { translateEnglishToSpanishBatch } from "../../Util/translator";

const FeaturedMixesDetail = () => {

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    // Get ID from URL
    const { id } = useParams();
    const tracks = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);
    const isPlaying = useSelector((state) => state.player.isPlaying);

    // Get Data From Redux
    const [isImageLoading, setIsImageLoading] = useState(true);
    const [loading, setLoading] = useState(true);

    // Set Use Sate 
    const [featuredMixData, setFeaturedMixData] = useState({});
    const [isSelected, setIsSelected] = useState(false);
    const [translatedTitle, setTranslatedTitle] = useState(null);
    const [translatedDescription, setTranslatedDescription] = useState(null);
    const [translationLoading, setTranslationLoading] = useState(false);

    // Sample Mix Data
    // const [featuredMixData, setFeaturedMixData] = useState({
    //     "id": 179,
    //     "sounds_list": [
    //         {
    //             "id": 5977,
    //             "sounds_detail": [
    //                 {
    //                     "id": 519,
    //                     "soundscategoriesname": "Nature",
    //                     "type": "sounds",
    //                     "subcategory_obj": {
    //                         "child_subcategory_id": null,
    //                         "child_subcategory_name": null
    //                     },
    //                     "soundcategory": 165,
    //                     "title": "Thunder",
    //                     "duration": "189.518367",
    //                     "audio": "https://storage.googleapis.com/relax_prod/assets/Thunder_-_OGG_-_28_lufs.ogg",
    //                     "image": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Thunder.png",
    //                     "banner": "https://storage.googleapis.com/relax_prod/assets/no_image.png",
    //                     "thumbnail": "https://storage.googleapis.com/relax_prod/assets/Transparent_-_WithoutCircle-_256_znvLqP9.svg",
    //                     "premium": false,
    //                     "created_datetime": "2023-12-19T09:32:20.058890-05:00",
    //                     "naration": false,
    //                     "featured": false,
    //                     "ios_sound": "https://storage.googleapis.com/relax_prod/assets/Thunder_-_2_min_-_28_lufs.mp3",
    //                     "ios_patch": "https://storage.googleapis.com/relax_prod/assets/Thunder_-_2_30_Min_-_28_lufs.mp3",
    //                     "audio_mobile": "https://storage.googleapis.com/relax_prod/assets/Thunder_-_Mp3_-_28_lufs.mp3",
    //                     "sequence": 7,
    //                     "hidden": false
    //                 }
    //             ],
    //             "name": "Thunder",
    //             "tumbnail": "https://storage.googleapis.com/relax_prod/assets/Transparent_-_WithoutCircle-_256_znvLqP9.svg",
    //             "image": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Thunder.png",
    //             "audio": "https://storage.googleapis.com/relax_prod/assets/Thunder_-_OGG_-_28_lufs.ogg",
    //             "type": "sounds",
    //             "narrate": false,
    //             "sound": 519,
    //             "volume": null,
    //             "soundmix": 125
    //         },
    //         {
    //             "id": 5978,
    //             "sounds_detail": [
    //                 {
    //                     "id": 258,
    //                     "meditationcategoriesname": "Mindfulness",
    //                     "type": "relaxation",
    //                     "subcategory_obj": {
    //                         "child_subcategory_id": null,
    //                         "child_subcategory_name": null
    //                     },
    //                     "meditationcategory": 22,
    //                     "title": "Improve Focus",
    //                     "duration": "515.082449",
    //                     "audio": "https://storage.googleapis.com/relax_prod/assets/2306201101_-_Improve_Focus_mixdown_edit_FINAL_2__-14_LUFS.mp3",
    //                     "image": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Improve-Focus_kvyViGD.png",
    //                     "banner": "https://storage.googleapis.com/relax_prod/assets/no_image.png",
    //                     "thumbnail": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Improve-Focus_dirwyhm.png",
    //                     "premium": false,
    //                     "text": "",
    //                     "genre": null,
    //                     "created_datetime": "2023-12-27T12:15:17.074525-05:00",
    //                     "naration": false,
    //                     "featured": true,
    //                     "sequence": 1,
    //                     "featured_sequence": 0
    //                 }
    //             ],
    //             "name": "Improve Focus",
    //             "tumbnail": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Improve-Focus_dirwyhm.png",
    //             "image": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Improve-Focus_kvyViGD.png",
    //             "audio": "https://storage.googleapis.com/relax_prod/assets/2306201101_-_Improve_Focus_mixdown_edit_FINAL_2__-14_LUFS.mp3",
    //             "type": "relaxation",
    //             "narrate": false,
    //             "sound": 258,
    //             "volume": null,
    //             "soundmix": 125
    //         },
    //         {
    //             "id": 5979,
    //             "sounds_detail": [
    //                 {
    //                     "id": 580,
    //                     "soundscategoriesname": "Music",
    //                     "type": "sounds",
    //                     "subcategory_obj": {
    //                         "child_subcategory_id": null,
    //                         "child_subcategory_name": null
    //                     },
    //                     "soundcategory": 164,
    //                     "title": "Awakening Soul",
    //                     "duration": null,
    //                     "audio": "https://storage.googleapis.com/relax_prod/assets/ETH-0009_-_Awakening_Soul__-20_dB_LUFS.ogg",
    //                     "image": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Awakening-Soul.png",
    //                     "banner": "https://storage.googleapis.com/relax_prod/assets/no_image.png",
    //                     "thumbnail": "https://storage.googleapis.com/relax_prod/assets/Transparent_-_WithoutCircle-_256_Ifq5WkT.svg",
    //                     "premium": false,
    //                     "created_datetime": "2023-12-19T16:48:20.665224-05:00",
    //                     "naration": false,
    //                     "featured": false,
    //                     "ios_sound": "https://storage.googleapis.com/relax_prod/assets/ETH-0009_-_Awakening_Soul__at_-20_dB_LUFS.mp3",
    //                     "ios_patch": "https://storage.googleapis.com/relax_prod/assets/ETH-0009_-_Awakening_Soul_Patch_iOS_for_-20_dB_LUFS.mp3",
    //                     "audio_mobile": "https://storage.googleapis.com/relax_prod/assets/ETH-0009_-_Awakening_Soul__at_-20_dB_LUFS_Er6YMsA.mp3",
    //                     "sequence": 161,
    //                     "hidden": false
    //                 }
    //             ],
    //             "name": "Awakening Soul",
    //             "tumbnail": "https://storage.googleapis.com/relax_prod/assets/Transparent_-_WithoutCircle-_256_Ifq5WkT.svg",
    //             "image": "https://storage.googleapis.com/relax_prod/assets/Relax-Scofa-Awakening-Soul.png",
    //             "audio": "https://storage.googleapis.com/relax_prod/assets/ETH-0009_-_Awakening_Soul__-20_dB_LUFS.ogg",
    //             "type": "sounds",
    //             "narrate": false,
    //             "sound": 580,
    //             "volume": null,
    //             "soundmix": 125
    //         }
    //     ],
    //     "mix_featured_category_name": "Latest Category Before Demo",
    //     "mix_featured_category_banner": "https://storage.googleapis.com/relax_prod/assets/Latest_Category.png",
    //     "name": "save mix",
    //     "position": 1,
    //     "banner": "https://storage.googleapis.com/relax_prod/assets/avif_test_2.jpg",
    //     "featured": true,
    //     "updated_at": "2024-11-19T09:06:29.074020-05:00",
    //     "featured_mix_status": false,
    //     "title": "Winter Whispers",
    //     "description": "test",
    //     "user": 4099,
    //     "featured_category": 26,
    //     "sub_category": 27
    // })

    useEffect(() => {
        if (id) {
            dispatch(userLogout())
            getDataByApi(id);
        }
    }, [id])

    useEffect(() => {
        if (config?.type === "mix") {
            setIsSelected(config['id'] == id);
        }
    }, [tracks, id]);

    const getDataByApi = async () => {
        try {
            const response = await axios.get(`${BASEURL}/api/sounds/mixture-categories/${id}`);
            setLoading(false);
            if (response.data.error !== true) {
                setFeaturedMixData(response.data.data?.[0]);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    // Auto-translate title & description for Spanish users (pilot on FeaturedMixes route)
    useEffect(() => {
        const applyTranslation = async () => {
            // Only translate when user language is Spanish and we have content
            if (i18n.language !== "es") {
                setTranslatedTitle(null);
                setTranslatedDescription(null);
                return;
            }

            if (!featuredMixData?.title && !featuredMixData?.description) {
                return;
            }

            try {
                setTranslationLoading(true);

                const texts = [];
                const indexMap = {};

                if (featuredMixData?.title) {
                    indexMap.title = texts.length;
                    texts.push(featuredMixData.title);
                }

                if (featuredMixData?.description) {
                    indexMap.description = texts.length;
                    texts.push(featuredMixData.description);
                }

                if (texts.length === 0) {
                    setTranslationLoading(false);
                    return;
                }

                const result = await translateEnglishToSpanishBatch(texts);

                if (result.success && Array.isArray(result.translatedTexts)) {
                    if (indexMap.title !== undefined) {
                        setTranslatedTitle(result.translatedTexts[indexMap.title] || null);
                    } else {
                        setTranslatedTitle(null);
                    }

                    if (indexMap.description !== undefined) {
                        setTranslatedDescription(result.translatedTexts[indexMap.description] || null);
                    } else {
                        setTranslatedDescription(null);
                    }
                } else {
                    setTranslatedTitle(null);
                    setTranslatedDescription(null);
                }
            } catch (e) {
                console.error("FeaturedMixes translation failed:", e);
                setTranslatedTitle(null);
                setTranslatedDescription(null);
            } finally {
                setTranslationLoading(false);
            }
        };

        applyTranslation();
    }, [i18n.language, featuredMixData]);

    const handleCardClick = () => {

        const item = featuredMixData;
        // Active User
        dispatch(activeUser());

        // Add or remove tracks
        if (!isSelected) {
            dispatch(resetConfig());
            dispatch(addMultipleTracks({ item }));
            dispatch(setConfig({
                id: item?.id,
                type: 'mix',
                name: item?.title ?? item?.name
            }));
            dispatch(playAllTracks());
        } else {
            dispatch(togglePlayPause());
        }
    };

    return (
        <MainLayout>
            <div className="go-back rotate">
                <Link to="/featured-mixes" state={{ from: '/featured-mixes-single' }}><img src={BackButtonNew} className="mw-100 w-22" /> </Link>
            </div>
            <div className="audio-detail-page mt-3 mt-sm-4">
                <div className="row">
                    <div className="col-lg-12 m-auto">
                        {
                            !loading && (
                                <div className="box-wrapper">
                                    <div className={`image-thumbnail ${isImageLoading ? "d-none" : ""}`}>
                                        <img
                                            src={featuredMixData?.banner}
                                            className="img-fluid w-100 rounded-4"
                                            onLoad={() => setIsImageLoading(false)}
                                        />
                                    </div>
                                    <div className="content text-center px-3">
                                        <h6 className="text-white text-capitalize mt-4 pt-2" >{t("nav.featuredMixes")}</h6>
                                        <h3 className="text-white my-3 my-sm-4 px-4">
                                            {translatedTitle || featuredMixData.title}
                                        </h3>

                                        <div className="ppButton mt-3 mt-sm-0 pt-sm-2">
                                            <button
                                                type="button"
                                                className="no-button"
                                                onClick={handleCardClick}
                                            >
                                                {isSelected && isPlaying ? (
                                                    <img src={PauseButton} />
                                                ) : (
                                                    <img src={PlayButton} />
                                                )}
                                            </button>
                                        </div>
                                        {translatedDescription ? (
                                            <p className="text-white mb-3 mt-4 fs-6 px-md-5">
                                                {translatedDescription}
                                            </p>
                                        ) : (
                                            featuredMixData.description && (
                                                <p
                                                    className="text-white mb-3 mt-4 fs-6 px-md-5"
                                                    dangerouslySetInnerHTML={{
                                                        __html: featuredMixData.description.replace(/\n/g, "<br />"),
                                                    }}
                                                />
                                            )
                                        )}

                                        {/* <p className="text-white mb-3 mt-4 fs-6 px-md-5" style={{ lineHeight: '1.7', wordBreak: 'break-word' }}>{featuredMixData.description}</p> */}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default FeaturedMixesDetail;